export default __webpack_public_path__ + "static/media/arDown.f0a7ce97.svg";